import { cn } from "@/libs/utils";
import React, { Fragment } from "react";
import {
  Dialog as RadixDialog,
  DialogContent,
} from "@/v2-components/ui/dialog";
import { Text } from "src/common/Text";
import { IconButton } from "./Buttons";
import CloseIcon from "./Icons";

type MaxWidth = "xs" | "sm" | "md" | "lg" | "xl" | false;

function CloseButton({
  className = "",
  onClick = () => {},
  size = 24,
}: {
  onClick?: () => void;
  className?: string;
  size?: number;
}) {
  return (
    <Fragment>
      <IconButton
        className={cn(className, "cursor-pointer")}
        onClick={onClick}
        icon={<CloseIcon size={size} />}
      />
    </Fragment>
  );
}

const maxWidthMap: Record<string, string> = {
  xs: "max-w-xs",
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
};

export function Dialog({
  onClose,
  hideCloseBtn = false,
  title = "",
  position = "center",
  maxWidth = "xs",
  className = "rounded-lg p-7 border border-gray-200",
  children,
  paperClassName,
}: {
  position?: "top" | "center" | "centerTop";
  onClose: () => void;
  hideCloseBtn?: boolean;
  maxWidth?: MaxWidth;
  className?: string;
  title?: string;
  children: any;
  paperClassName?: string;
}) {
  return (
    <RadixDialog open={true} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className={cn(
          "w-full shadow-[0px_2px_10px_0px_#00000026]",
          maxWidth && maxWidthMap[maxWidth],
          position === "center" ? "items-center" : "",
          paperClassName,
        )}
      >
        <div className={cn(className, "relative")}>
          <div className="flex items-center justify-between">
            {!!title && (
              <Text
                className={"text-gray-1 text-[24px] font-700"}
                text={title}
              />
            )}

            {!hideCloseBtn && (
              <div className="absolute right-[10px] top-[10px]">
                <CloseButton onClick={() => !!onClose && onClose()} />
              </div>
            )}
          </div>
          {children}
        </div>
      </DialogContent>
    </RadixDialog>
  );
}
